import { LazyLibId } from '@shared-features/enums/shared-enums.enum';
import { Injectable } from '@angular/core';
import { DynamicScriptService } from '@core/services/dynamic-script.service';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class LocationsApiService {
  isGoogleMapLoaded = false;

  constructor(private dynamicScriptService: DynamicScriptService) {
    this.loadGoogleMapsApi();
  }

  loadGoogleMapsApi(): Promise<void> {
    const mapsUrl = `https://maps.googleapis.com/maps/api/js?key=${environment.google_map_key}&libraries=places`;
    const clustererUrl = 'https://unpkg.com/@googlemaps/markerclustererplus/dist/index.min.js';

    return Promise.all([
      this.dynamicScriptService.loadDynamicScript(LazyLibId.googleMaps, mapsUrl),
      this.dynamicScriptService.loadDynamicScript(LazyLibId.googleMapsClusterer, clustererUrl),
    ]).then(() => {
      this.isGoogleMapLoaded = true;
      return Promise.resolve();
    }).catch((error) => {
     console.log(error);
    });
  }
}
